import actions from 'src/modules/incident/importer/incidentImporterActions';
import importerReducers from 'src/modules/shared/importer/importerReducers';

export default importerReducers(actions);
